// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qh-0";